import React, { createContext, useContext, useState, useEffect } from 'react';

const AppContext = createContext<any>(null);

export const AppProvider = ({ children }: { children: React.ReactNode }) => {
  const [products, setProducts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  // 📡 SYNCHRONISATION AUTOMATIQUE AVEC LE GISEMENT
  useEffect(() => {
    const loadData = async () => {
      try {
        console.log("🔄 Tentative de récupération du gisement...");
        // On essaie de charger le fichier JSON sur le serveur
        const response = await fetch('/data/panier-anticrise.json?t=' + Date.now());
        
        if (response.ok) {
          const data = await response.json();
          console.log(`✅ Gisement chargé : ${data.length} articles.`);
          setProducts(data);
          localStorage.setItem('aki_db', JSON.stringify(data));
        } else {
          // Si le serveur échoue, on regarde dans le stockage local
          const saved = localStorage.getItem('aki_db');
          if (saved) setProducts(JSON.parse(saved));
        }
      } catch (error) {
        console.error("❌ Erreur de synchro :", error);
        const saved = localStorage.getItem('aki_db');
        if (saved) setProducts(JSON.parse(saved));
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  // 💾 SAUVEGARDE LOCALE À CHAQUE CHANGEMENT
  useEffect(() => {
    if (products.length > 0) {
      localStorage.setItem('aki_db', JSON.stringify(products));
    }
  }, [products]);

  const addScannedProduct = (newProduct: any) => {
    setProducts((prev: any) => [newProduct, ...prev]);
  };

  const clearDB = () => {
    localStorage.removeItem('aki_db');
    window.location.reload();
  };

  return (
    <AppContext.Provider value={{ products, loading, addScannedProduct, clearDB }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);

